import { BehaviorSubject } from "rxjs";

export class DinamicTitleService {
    private subject = new BehaviorSubject('');
    public data$ = this.subject.asObservable(); 

    setTitle(value : string){
        this.subject.next(value);
    }

}